import { Address, FeeTier, queryApi } from 'nftx.js';

type Response = {
  token0: Address;
  token1: Address;
  amountALower: bigint;
  amountACurrent: bigint;
  amountAUpper: bigint;
  tickLower: number;
  tickCurrent: number;
  tickUpper: number;
  sqrtRatioLowerX96: bigint;
  sqrtRatioCurrentX96: bigint;
  sqrtRatioUpperX96: bigint;
  addLiqAmount0: bigint;
  addLiqAmount1: bigint;
  addLiqAmount: bigint;
  addLiqTokenA: bigint;
  addLiqTokenB: bigint;
  vTokenAmount: bigint;
};

const calculateLiquidity = ({
  amountACurrent,
  amountALower,
  amountAUpper,
  feeTier,
  network,
  tokenB,
  addLiqAmountA,
  addLiqAmountB,
  fullRange,
}: {
  network: number;
  feeTier: FeeTier;
  tokenB: Address;
  amountALower: bigint;
  amountACurrent: bigint;
  amountAUpper: bigint;
  addLiqAmountA?: bigint;
  addLiqAmountB?: bigint;
  fullRange?: boolean;
}) => {
  return queryApi<Response>({
    url: `/${network}/positions/liquidity/calculate`,
    method: 'POST',
    query: {
      amountACurrent,
      amountALower,
      amountAUpper,
      feeTier,
      tokenB,
      addLiqAmountA,
      addLiqAmountB,
      fullRange,
    },
  });
};

export default calculateLiquidity;
